export const getMenu = state => state.menuR.menu;
